// extracted by mini-css-extract-plugin
export default {"containerDashboardP":"TabelaEPerdoruesve_containerDashboardP__MW-Om","modal":"TabelaEPerdoruesve_modal__01U7m"};